import {
    AfterViewInit,
    Component,
    DestroyRef,
    ElementRef,
    OnInit,
    TemplateRef,
    ViewChild,
    inject,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormService } from "@app/services/form.service";
import * as formDataIngestionRequestFields from "@app/services/form-data-ingestion2.json";
import KTWizard from "@assets/js/wizard";
import { UDFApiService } from "@app/services/udf-api.service";
import { BaseComponent } from "@app/components/base.component";
import { DatePipe } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "kepler-data-ingestion-request-form",
    templateUrl: "./data-ingestion-request.component.html",
    styleUrls: ["./data-ingestion-request.component.scss"],
})
export class DataIngestionRequestComponent
    extends BaseComponent
    implements OnInit, AfterViewInit
{
    private destroyChildRef = inject(DestroyRef);
    public formWarning: any = false;
    formDataIngestionRequestObject = (formDataIngestionRequestFields as any)
        .default;
    formUses = [].concat(this.formDataIngestionRequestObject);
    workflowForm: FormGroup;
    inProgress: boolean;
    wizard: any;
    submissionDialogRef: any;
    htmlBuilder: any;
    selections: any[];
    @ViewChild("wizard", { static: false }) el: ElementRef;
    @ViewChild("submissionDialog", { static: false })
    submissionDialog: TemplateRef<any>;
    @ViewChild('formElemRef') formElemRef! : ElementRef<HTMLFormElement>;

    constructor(
        private formSvc: FormService,
        private udfApiSvc: UDFApiService,
        private fb: FormBuilder,
        private _snackBar: MatSnackBar,
        public dialog: MatDialog,
    ) {
        super();
        console.log(this.formDataIngestionRequestObject);
    }
    ngOnInit(): void {
        this.workflowForm = this.formSvc.createControls(this.fb, this.formUses);
        this.formSvc.watchControlChanges(this.formUses, this.workflowForm);

        this.subscribeToStore(this.udfApiSvc.getTags(), (data) => {
            this.formUses.forEach((field) => {
                if (field.id === "dataInformation") {
                    field.group.forEach((group) => {
                        if (group.id === "l1Tags") {
                            group.type.tags = data.assetTags;
                        } else if (group.id === "l2Tags") {
                            group.type.tags = data.domainTags;
                            group.type.tags.push("Other");
                        }
                    });
                }
            });
        });

        this.formUses
            .filter((r) => r.id === "selectIngestionDataType")[0]
            .group.forEach((l) => {
                this.workflowForm.controls["selectIngestionDataType"]
                    .get(l.id)
                    .valueChanges.pipe(takeUntilDestroyed(this.destroyChildRef))
                    .subscribe((val) => {
                        setTimeout(() => {
                            this.formSvc.resetFormControlValues(
                                this.formUses,
                                this.workflowForm,
                            );
                            this.formSvc.watchParentChanges(
                                this.formUses,
                                this.workflowForm,
                                val,
                            );
                        }, 500);
                        let stepCount = 2;
                        this.formUses.forEach((item) => {
                            if (item.ingestionDataTypes) {
                                item.visible =
                                    item.ingestionDataTypes.includes(val);

                                if (item.visible) stepCount++;
                            }
                        });
                        this.wizard.totalSteps = stepCount;
                        setTimeout(() => {
                            this.wizard.goNext();
                        }, 500);
                    });
            });
    }

    ngAfterViewInit(): void {
        this.wizard = new KTWizard(this.el.nativeElement, {
            startStep: 1,
            clickableSteps: true,
        });

        // Change event
        this.wizard.on("change", () => {
            setTimeout(() => {
                if (this.wizard.currentStep == this.wizard.totalSteps) {
                    this.buildHTMLLists();
                }
            }, 500);
        });
    }

    submit = () => {
        this.workflowForm.clearValidators();
        this.workflowForm.updateValueAndValidity();
        if (!this.workflowForm.valid) {
            this._snackBar.open(`Form Not Valid`, "Dismiss", {
                duration: 6000,
            });
            return;
        }
        this._snackBar.open(`Submitting Data Ingestion Request`, "Dismiss", {
            duration: 6000,
        });

        this.buildHTMLLists();

        let postDataObj = this.buildPostData();

        this.subscribeToStore(
            this.udfApiSvc.postIngestionRequest(postDataObj),
            (x) => {
                console.log(x);
                this.submissionDialogPopup();
            },
        );
    };

    submissionDialogPopup(): void {
        this.submissionDialogRef = this.dialog.open(this.submissionDialog, {
            height: "80%",
            width: "80%",
            data: this.htmlBuilder,
        });
        this.submissionDialogRef
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroyChildRef))
            .subscribe(() => this.refreshParent());
    }

    refreshParent() {
        this.workflowForm.reset();
        this.wizard.goTo(0);
    }

    buildHTMLLists() {
        let htmlLists = "";
        this.selections = [];
        let ingestionValueSelected = "";
        let selection: any;
        this.formUses.forEach((field) => {
            if (field && field.group.length) {
                if (field.id == "selectIngestionDataType") {
                    ingestionValueSelected = this.workflowForm.controls[
                        field.id
                    ].get(field.group[0].id).value;
                    return;
                }
                selection = {};
                selection.subItems = [];

                if (
                    field.ingestionDataTypes &&
                    field.ingestionDataTypes.includes(ingestionValueSelected)
                ) {
                    htmlLists += "<ul>";
                    htmlLists += `<li>${field.title}</li>`;
                    selection.title = field.title;

                    htmlLists += "<ul>";
                    let formControl = this.workflowForm.controls[field.id];
                    let value;
                    let status;
                    let isInvalidDataEntered;
                    field.group.forEach((item) => {
                        status = this.getFormControlStatus(item, formControl);
                        value = this.getFormControlValue(item, formControl);
                        isInvalidDataEntered =
                            this.getIsFormControlInValidDataEntered(
                                item,
                                formControl,
                            );
                        htmlLists += `<li>${item.label}: ${value}</li>`;
                        selection.subItems.push({
                            label: item.label,
                            formControlValue: value,
                            formControlStatus: status,
                            formControlErrors: isInvalidDataEntered,
                        });
                    });
                    this.selections.push(selection);

                    htmlLists += "</ul>";

                    htmlLists += "</ul>";
                }
            }
        });
        this.htmlBuilder = htmlLists;
    }

    getFormControlValue(item, formControl) {
        let formControlValue = formControl.get(item.id).value;

        if (
            item.type.type === "custom-select" &&
            this.isCustomOptionSelected(formControlValue, item)
        ) {
            let tempValue;
            let options = item.customOptions.filter(
                (element) => element.value == formControlValue,
            );

            if (options.length == 1) {
                formControlValue = formControl.get(
                    item.id + options[0].id,
                ).value;
                return formControlValue;
            }

            for (let index = 0; index < options.length; index++) {
                let element = options[index];

                tempValue = formControl.get(item.id + element.id).value;
                if (tempValue == null || tempValue == "") {
                    formControlValue = "";
                    break;
                }

                if (index == 0) {
                    formControlValue = "";
                }

                formControlValue =
                    formControlValue + element.label + ": " + tempValue;

                if (index < options.length - 1) {
                    formControlValue += "; ";
                }
            }
        } else if (item.type.type === "people-picker") {
            formControlValue =
                formControlValue !== null && formControlValue.length
                    ? formControlValue[0].displayName
                    : "";
        } else if (item.type.type === "ad-group-picker") {
            formControlValue =
                formControlValue !== null
                    ? formControlValue.map((x) => x.displayName).join(", ")
                    : "";
        } else if (item.type.type === "tagger") {
            if (this.isCustomOptionSelected(formControlValue, item)) {
                formControlValue = [...formControlValue];
                formControlValue.forEach((element, index) => {
                    if (element === "Other") {
                        formControlValue[index] = formControl.get(
                            item.id + "Other",
                        ).value;
                    }
                });
            }
            formControlValue =
                formControlValue !== null &&
                formControlValue.every((x) => x !== "" && x !== null)
                    ? formControlValue.join(", ")
                    : "";
        } else if (item.type.type === "date") {
            let date = formControlValue;
            let pipe = new DatePipe("en-US");

            formControlValue =
                date !== null
                    ? pipe.transform(date, "yyyy-MM-dd HH:mm:ss")
                    : "";
        }

        return formControlValue ?? "";
    }

    getFormControlStatus(item, formControl) {
        let formControlStatus = formControl.get(item.id).valid;
        let formControlValue = formControl.get(item.id).value;

        if (
            (item.type.type === "custom-select" ||
                item.type.type === "tagger") &&
            this.isCustomOptionSelected(formControlValue, item)
        ) {
            formControlStatus = item.customOptions
                .filter(
                    (element) =>
                        element.value == formControlValue ||
                        formControlValue.includes(element.value),
                )
                .every(
                    (element) =>
                        formControl.get(item.id + element.id).valid == true,
                );
        }

        return formControlStatus;
    }

    getIsFormControlInValidDataEntered(item, formControl) {
        let formControlErrors = formControl.get(item.id).errors;
        if (formControlErrors == null || formControlErrors.required == true)
            return false;
        else return true;
    }

    buildPostData() {
        let isPartialIngestionSelected: boolean =
            this.workflowForm.controls["selectIngestionDataType"].get(
                "ingestionTypes",
            ).value == "existing";
        let titleObj: string =
            this.workflowForm.controls[
                isPartialIngestionSelected
                    ? "partialIngestion"
                    : "basicInformation"
            ].get("requestTitle").value;

        let postDataObj: any = {};
        postDataObj.title = titleObj;
        postDataObj.description = this.htmlBuilder;
        postDataObj.areaPath = isPartialIngestionSelected
            ? "partialIngestion"
            : "";
        // postDataObj.fileAttachment = this.fileAttachment;
        return postDataObj;
    }

    hiddenSubmit() {
        document.getElementById("wizard-submit").click();
    }

    isRequired(item) {
        return item.validations.length > 0;
    }

    isIngestionTypeSelected() {
        return (
            this.workflowForm.controls["selectIngestionDataType"].get(
                "ingestionTypes",
            ).value !== ""
        );
    }

    isCustomOptionSelected(value, item) {
        let elementFound: boolean;
        if (item.customOptions) {
            item.customOptions.forEach((element) => {
                if (
                    element.value === value ||
                    (Array.isArray(value) && value.includes(element.value))
                )
                    elementFound = true;
            });
        }

        return elementFound;
    }

    scrollTop() {
        window.scrollTo(0, 370);
    }
}
